export const canAccessLeadershipAnalytics = (user) => {
  if (!user) {
    return false;
  }

  if (user.typeOfUser === 'Admin') {
    return true;
  }

  if (user.typeOfUser === 'Leadership' || user.roleOfUser === 'Leadership') {
    return true;
  }

  return false;
};
